import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "../components/SEO";
import "../Styles/GuidancePage.css";
import "../Styles/GuidanceRespond.css";
import "../Styles/GuidanceReflection.css";

export default function GuidanceReflection() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const id = params.get("id");
  const token = params.get("token");

  const [takeaway, setTakeaway] = useState("");
  const [useful, setUseful] = useState("");
  const [explore, setExplore] = useState("");
  const [permission, setPermission] = useState("anonymous");

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!id || !token) {
      setError("This link is missing some details.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      const res = await fetch("/api/guidance/reflection-submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, token, takeaway, useful, explore, permission }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || "Could not send — please try again.");
      setDone(true);
    } catch (err) {
      setError(err.message);
    }
    setSubmitting(false);
  };

  const renderBody = () => {
    if (!id || !token) {
      return (
        <div className="gr-card gr-error-card">
          <span className="gr-icon">✕</span>
          <h1>Link not found</h1>
          <p>This link is missing some details — please use the link from your email.</p>
        </div>
      );
    }

    if (done) {
      return (
        <div className="gr-card">
          <span className="gr-icon gr-icon-ok">✓</span>
          <h1>Thank you</h1>
          <p>Your reflection has been shared. It genuinely means a lot to hear what stayed with you.</p>
        </div>
      );
    }

    return (
      <div className="gr-card gr-reflection-card">
        <h1>Your Session Reflection</h1>
        <p>It should take just a couple of minutes.</p>
        <form className="gp-form" onSubmit={submit} noValidate>
          <label className="gp-label">
            <span>What was your biggest takeaway from our conversation?</span>
            <textarea value={takeaway} onChange={(e) => setTakeaway(e.target.value)} maxLength={2000} />
          </label>
          <label className="gp-label">
            <span>What was most useful to you?</span>
            <textarea value={useful} onChange={(e) => setUseful(e.target.value)} maxLength={2000} />
          </label>
          <label className="gp-label">
            <span>Is there anything from our conversation you'd like to explore further?</span>
            <textarea value={explore} onChange={(e) => setExplore(e.target.value)} maxLength={2000} />
          </label>

          <div className="gr-permission">
            <span className="gr-permission-label">May I share your words?</span>
            <label className="gr-permission-option">
              <input type="radio" name="permission" value="named" checked={permission === "named"} onChange={() => setPermission("named")} />
              Yes, with my name
            </label>
            <label className="gr-permission-option">
              <input type="radio" name="permission" value="anonymous" checked={permission === "anonymous"} onChange={() => setPermission("anonymous")} />
              Yes, anonymously
            </label>
            <label className="gr-permission-option">
              <input type="radio" name="permission" value="private" checked={permission === "private"} onChange={() => setPermission("private")} />
              Please keep this private
            </label>
            <p className="gr-permission-note">Your response will only be shared publicly if you give permission above.</p>
          </div>

          {error && <p className="gp-error">{error}</p>}
          <button type="submit" className="gp-submit-btn" disabled={submitting}>
            {submitting ? "Sending…" : "Share my reflection →"}
          </button>
        </form>
      </div>
    );
  };

  return (
    <>
      <SEO title="Your session reflection — The PP Studio" description="Share a quick reflection on your guidance session." noIndex />
      <Navbar />
      <main className="gr-main">{renderBody()}</main>
      <Footer />
    </>
  );
}
